export default __webpack_public_path__ + "static/media/dessert1.c685faad.jpg";